(ns story-builder.font.constant
  (:require
   [story-builder.translation :refer [tr]]))

;; The font types in the order we want them to be displayed in the UI.
(def font-types
  ["SERIF"
   "SANS_SERIF"
   "DISPLAY"
   "HANDWRITING"
   "MONOSPACE"])

;; The display name for each font type.
(def font-type->display-name
  {"SERIF"       "Serif"
   "SANS_SERIF"  "Sans Serif"
   "DISPLAY"     "Display"
   "HANDWRITING" "Handwriting"
   "MONOSPACE"   "Monospace"})

;; The font sets in the order we want them to be displayed in the UI.
(def font-sets
  ["DEFAULT"
   "MY_FONTS"
   #_"LOANED"])

;; The display name for each font set.
(def font-set->display-name
  {"DEFAULT"  "Built-in"
   "MY_FONTS" "My Fonts"
   "LOANED"   "Loaned"})

(def type-choices
  {"SANS_SERIF"  (tr [:sans-serif "Sans-serif"])
   "SERIF"       (tr [:serif "Serif"])
   "MONOSPACE"   (tr [:monospace "Monospace"])
   "DISPLAY"     (tr [:display "Display"])
   "HANDWRITING" (tr [:handwriting "Handwriting"])})

(def weight-choices
  {"THIN"       (tr [:thin "Thin"])
   "EXTRALIGHT" (tr [:extralight "Extra Light"])
   "LIGHT"      (tr [:light "Light"])
   "REGULAR"    (tr [:regular "Regular"])
   "MEDIUM"     (tr [:medium "Medium"])
   "SEMIBOLD"   (tr [:semibold "Semi Bold"])
   "BOLD"       (tr [:bold "Bold"])
   "EXTRABOLD"  (tr [:extrabold "Extra Bold"])
   "BLACK"      (tr [:black "Black"])})

(def weight-choice->weight
  {"THIN"       100
   "EXTRALIGHT" 200
   "LIGHT"      300
   "REGULAR"    400
   "MEDIUM"     500
   "SEMIBOLD"   600
   "BOLD"       700
   "EXTRABOLD"  800
   "BLACK"      900})